var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalApplication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Browser, Internet, Web, Network, Check",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17061",
    stroke: "#304393",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12648",
    d: "M13.69 8.309a3.333 3.333 0 11-4.714 0 3.333 3.333 0 014.714 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12649",
    d: "M6.577 3.663v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12650",
    d: "M4.884 3.663v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12651",
    d: "M3.185 3.66v0h0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12652",
    d: "M1.333 5.333h11.333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12653",
    d: "M12.666 7.611V3.333A1.333 1.333 0 0011.333 2H2.666a1.333 1.333 0 00-1.333 1.333v7.333A1.333 1.333 0 002.666 12h5.612"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12654",
    d: "M12.815 9.926l-1.852 1.852-1.111-1.111"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12655",
    d: "M0 0h16v16H0z"
  }))));
}
export default SvgDigitalApplication;


//////////////////
// WEBPACK FOOTER
// ./src/icons/digitalApplication.svg
// module id = 757
// module chunks = 13